import { pathOr } from "ramda";
import { GRAPH_URL } from "../../../constants";

const query = `
    query UserUnlockedFeatures {
        userUnlockedFeatures {
            watermark
            watermarkPrice
            video
            videoPrice
            unlockTopNinePrice
            watermarkPurchaseEnabled
            loginEnabled
            videoFeatureEnabled
            gridDelay
            exceptionsWithPaymentButton
        }
    }`;

const getUserUnlockFeatures = variables =>
  fetch(GRAPH_URL, {
    method: "POST",
    headers: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ query }),
  })
    .then(res => res.json())
    .then(res => {
      const unlockedFeatures = pathOr(null, ["data", "userUnlockedFeatures"])(res);
      return {
        lockedVideo: !unlockedFeatures.video,
        ...unlockedFeatures,
      };
    })
    .catch(error => console.log("Error  getUserUnlockFeatures", { error }));

export default getUserUnlockFeatures;
